import React from 'react';
import { RentPaymentDashboard } from './RentPaymentDashboard';
import { useHistory } from 'react-router-dom';
import { usePremiumHelpers } from 'hook/premium.hook';
import { useRentPaymentDashboard } from 'partial/OfferManager/modules/RentPaymentDashboard/hooks/rentPaymentDashboard.hook';
import { useRentPaymentReportHelpers } from 'hook/rentPaymentReport.hook';
import { RENT_PAYMENT_DASHBOARD } from 'types/morph.pagePosition.constants';
import { getViewModuleTrackingAttributes } from 'helpers/tracking.helpers';
import { useViewModule, useSeenModulePixel } from 'hook/helper.hook';
import { useFlag } from 'hook/flag.hook';
import { isVariationLoadedAndEnabled } from 'helpers/optimizely.helper';

const RentPaymentDashboardController = props => {
  const premium = usePremiumHelpers(props.eventHandler);
  const history = useHistory();
  const rentPaymentDashboard = useRentPaymentDashboard(
    props.userInfo,
    history,
    props.eventHandler,
    props.modulePosition,
  );
  const rentPaymentReport = useRentPaymentReportHelpers(props.eventHandler);
  const atr = getViewModuleTrackingAttributes({
    pagePosition: RENT_PAYMENT_DASHBOARD,
    modulePosition: props.modulePosition,
    vertical: 'Rent Reporting',
  });
  useViewModule(atr, true);
  const seenPixel = useSeenModulePixel(atr);

  const rentReportingPreQualificationFlag = useFlag(
    'premium_rent_reporting_pre_qualification',
  );
  const isOptimizelyRentPreQualification = isVariationLoadedAndEnabled(
    rentReportingPreQualificationFlag,
  );
  const rentReportingPreQualification = {
    config: rentReportingPreQualificationFlag?.config,
    isEnabled: isOptimizelyRentPreQualification,
    onClickRentReportingPreQualFlow:
      rentPaymentReport.onClickRentReportingPreQualFlow,
  };

  return (
    <>
      {seenPixel}
      <RentPaymentDashboard
        {...rentPaymentReport}
        {...rentPaymentDashboard}
        eventHandler={props.eventHandler}
        premium={premium}
        onEnrollRentPaymentReport={rentPaymentReport.rentPaymentEnrollment}
        onEnrollRentPaymentAuthenticate={
          rentPaymentReport.rentPaymentAuthenticate
        }
        getRentPaymentText={rentPaymentReport.getRentPaymentText}
        modulePosition={props.modulePosition}
        userInfo={props.userInfo}
        creditInfo={props.creditInfo}
        onRentPaymentRentalInfo={rentPaymentReport.rentPaymentRentalInfo}
        onRentPaymentTracking={rentPaymentReport.rentPaymentButtonTracking}
        rentReportingPreQualification={rentReportingPreQualification}
      />
    </>
  );
};

export default RentPaymentDashboardController;
